var SENTRY_RELEASE;SENTRY_RELEASE={name: "Eon", version: "3.32.0"};